/* globals google */
'use strict';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
  var newUrl = url;
  newUrl +=
    (newUrl.indexOf('?') !== -1 ? '&' : '?') +
    Object.keys(params)
      .map(function(key) {
        return key + '=' + encodeURIComponent(params[key]);
      })
      .join('&');

  return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
  var map;
  var infowindow = new google.maps.InfoWindow();

  // Init Rome in the center of the viewport
  var latlng = new google.maps.LatLng(41.902782, 12.496366);
  var mapOptions = {
    scrollwheel: false,
    zoom: 4,
    center: latlng,
    maxZoom: 18
  };

  map = new google.maps.Map($('.map-canvas')[0], mapOptions);
  var mapdiv = $('.map-canvas').attr('data-locations');

  mapdiv = JSON.parse(mapdiv);

  var bounds = new google.maps.LatLngBounds();

  // Customized google map marker icon with svg format
  var markerImg = {
    path:
      'M13.5,30.1460153 L16.8554555,25.5 L20.0024287,25.5 C23.039087,25.5 25.5,' +
      '23.0388955 25.5,20.0024287 L25.5,5.99757128 C25.5,2.96091298 23.0388955,0.5 ' +
      '20.0024287,0.5 L5.99757128,0.5 C2.96091298,0.5 0.5,2.96110446 0.5,5.99757128 ' +
      'L0.5,20.0024287 C0.5,23.039087 2.96110446,25.5 5.99757128,25.5 L10.1445445,' +
      '25.5 L13.5,30.1460153 Z',
    fillColor: '#bc260b',
    fillOpacity: 1,
    scale: 1.1,
    strokeColor: 'white',
    strokeWeight: 1,
    anchor: new google.maps.Point(13, 30),
    labelOrigin: new google.maps.Point(12, 12)
  };

  Object.keys(mapdiv).forEach(function(key) {
    var item = mapdiv[key];
    var lable = parseInt(key, 10) + 1;
    var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
    var flag = false;
    if (item.infoWindowHtml && item.infoWindowHtml.includes('gold-button-storelocator')) {      
      flag = true;
      item.infoWindowHtml = item.infoWindowHtml.replace(
        /<label class="gold-button-storelocator"[^>]*>/,
        '<label class="gold-button-storelocator" style="display:none;">'
    );
    }
    markerImg.fillColor = flag ? '#C17F07' : '#bc260b';
    var marker = new google.maps.Marker({
      position: storeLocation,
      map: map,
      title: item.name,
      icon: markerImg,
      label: { text: lable.toString(), color: 'white', fontSize: '16px' }
    });

    marker.addListener('click', function() {
      infowindow.setOptions({
        content: item.infoWindowHtml
      });
      infowindow.open(map, marker);
    });

    // Create a minimum bound based on a set of storeLocations
    bounds.extend(marker.position);
  });
  // Fit the all the store marks in the center of a minimum bounds when any store has been found.
  if (mapdiv && mapdiv.length !== 0) {
    map.fitBounds(bounds);
  }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
  var $resultsDiv = $('.results');
  var $mapDiv = $('.map-canvas');
  var hasResults = data.stores.length > 0;
  var $goldButton = $('.recursive-gold-button-storelocator').html();

  if (!hasResults) {
    $('.store-locator-no-results').show();
  } else {
    $('.store-locator-no-results').hide();
  }

  $resultsDiv
    .empty()
    .data('has-results', hasResults)
    .data('radius', data.radius)
    .data('search-key', data.searchKey);

  $mapDiv.attr('data-locations', data.locations);

  if ($mapDiv.data('has-google-api')) {
    maps();
  } else {
    $('.store-locator-no-apiKey').show();
  }

  if (data.storesResultsHtml) {

    $resultsDiv.append(data.storesResultsHtml);
    var buttons = document.querySelectorAll('.gold-button-storelocator');
    buttons.forEach(color => {
      color.innerHTML =$goldButton;
    });
  }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
  var dialog = element.closest('.in-store-inventory-dialog');
  var spinner = dialog.length ? dialog.spinner() : $.spinner();
  spinner.start();
  var $form = element.closest('.store-locator');
  var radius = $('.results').data('radius');
  var url = $form.attr('action');
  var urlParams = { radius: radius };
  var flag_solo_expert = $('#expertAgencyHidden').val();
  //var payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };
  var productStoreLocatorValue = $('#cofanetto-selected-value').val();
  var geonameStoreLocatorValue = $('#selected-value').val();

  var payload = {
      gename_id: geonameStoreLocatorValue,
      cod_prodotto: productStoreLocatorValue,
      flag_solo_expert: flag_solo_expert
  };

  url = appendToUrl(url, urlParams);

  $.ajax({
    url: url,
    type: $form.attr('method'),
    data: payload,
    dataType: 'json',
    success: function(data) {
      spinner.stop();
      updateStoresResults(data);
      $('.select-store').prop('disabled', true);
    }
  });
  return false;
}
$(document).ready(function () {
  $(document).on("input", "#location-picker", function () {
    if ($(this).val() === "") {        
        $("#selected-name").val("");
        $("#selected-value").val("");
    }
  });
});
$(document).ready(function () {
  $(document).on("input", "#confanetto-picker", function () {
    if ($(this).val() === "") {        
        $("#cofanetto-selected-name").val("");
        $("#cofanetto-selected-value").val("");
    }
  });
});
function detectLocationAjaxRequest (lat, long) {
  var $detectLocationButton = $('.detect-location');
  var url = $detectLocationButton.data('action');
  var radius = $('.results').data('radius');
  var flag_solo_expert = $('#expertAgencyHidden').val();
  var urlParams = {
    radius: radius,
    lat: lat,
    long: long,
    flag_solo_expert: flag_solo_expert
  };
  $("#selected-name").val("");
  $("#selected-value").val("");
  $("#location-picker").val("");          
  $("#cofanetto-selected-name").val("");
  $("#cofanetto-selected-value").val("");
  $("#confanetto-picker").val("");
  url = appendToUrl(url, urlParams);
  $.ajax({
    url: url,
    type: 'get',
    dataType: 'json',
    success: function(data) {
      $.spinner().stop();
      updateStoresResults(data);
      $('.select-store').prop('disabled', true);
    }
  });
}
module.exports = {
  init: function() {
    if ($('.map-canvas').data('has-google-api')) {
      maps();
    } else {
      $('.store-locator-no-apiKey').show();
    }

    if (!$('.results').data('has-results')) {
      $('.store-locator-no-results').show();
    }
  },

  detectLocation: function() {
    // clicking on detect location.
    $('.detect-location').on('click', function() {
      $.spinner().start();
      if (!navigator.geolocation) {
        $.spinner().stop();
        return;
      }

      navigator.geolocation.getCurrentPosition(
        function(position) {
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          detectLocationAjaxRequest(latitude, longitude);
        },
        function(error) {
          $.spinner().stop();
          var defaultLatitude = 45.4642;
          var defaultLongitude = 9.1900;
          detectLocationAjaxRequest(defaultLatitude, defaultLongitude);
        }
      );
    });
  }, 

  search: function() {
    $('.store-locator-container form.store-locator').submit(function(e) {
      e.preventDefault();
      search($(this));
    });
    $('.store-locator-container .btn-storelocator-search[type="button"]').click(function(e) {
      e.preventDefault();
      search($(this));
    });
  },

  changeRadius: function() {
    $('.store-locator-container .radius').change(function() {
      var radius = $(this).val();
      var searchKeys = $('.results').data('search-key');
      var url = $(this).data('action-url');
      var urlParams = {};      
      var geoname = $('#selected-name').val();
      var prodName = $('#cofanetto-selected-name').val();
      var gename_id = $('#selected-value').val();     
      var cod_prodotto = $('#cofanetto-selected-value').val();
      var flag_solo_expert = $('#expertAgencyHidden').val();
      if(geoname !== '' || prodName !== ''){
        urlParams = {
          radius: radius,
          gename_id: gename_id,
          cod_prodotto: cod_prodotto,
          flag_solo_expert: flag_solo_expert
        };
      }else{
        urlParams = {
          radius: radius,
          lat: searchKeys.lat,
          long: searchKeys.long,
          flag_solo_expert: flag_solo_expert
        };
      }
      url = appendToUrl(url, urlParams);
      var dialog = $(this).closest('.in-store-inventory-dialog');
      var spinner = dialog.length ? dialog.spinner() : $.spinner();
      spinner.start();
      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function(data) {
          spinner.stop();
          updateStoresResults(data);
          $('.select-store').prop('disabled', true);
        }
      });
    });
  },
  selectStore: function() {
    $('.store-locator-container').on('click', '.select-store', function(e) {
      e.preventDefault();
      var selectedStore = $(':checked', '.results-card .results');
      var data = {
        storeID: selectedStore.val(),
        searchRadius: $('#radius').val(),
        searchPostalCode: $('.results').data('search-key').postalCode,
        storeDetailsHtml: selectedStore
          .siblings('label')
          .find('.store-details')
          .html(),
        event: e
      };

      $('body').trigger('store:selected', data);
    });
  },
  updateSelectStoreButton: function() {
    $('body').on('change', '.select-store-input', function() {
      $('.select-store').prop('disabled', false);
    });
  },
  isCheckedExpert: function () {
    $(document).ready(function () {
        var $checkbox = $('#expertAgency');
        var $hiddenInput = $('#expertAgencyHidden');
        $hiddenInput.val($checkbox.prop('checked') ? 'true' : 'false');
        $checkbox.on('change', function () {
            $hiddenInput.val($(this).prop('checked') ? 'true' : 'false');
        });
    });
  }

};
